Vendd.Scripts.load(function () {
    initMainMenu();
});

function initMainMenu() {

    var $wrapper = $('.js-main-menu');

    var $firstLevel = $('.nav-1 > li > a', $wrapper);

    if (!isTouch()) {
        initMainMenuEffects($firstLevel);

        $wrapper.on("mouseleave", function (e) {
            $('.nav-1 > li',$wrapper).removeClass('hovered');
        });
    } else {
      
        $wrapper.on('click', '.nav-1 > li.hasChildren >.title', function (e) {
            var $this = $(this);
            var $el = $this.parent();

            $el.siblings('.hovered').removeClass('hovered');
            $el.addClass('hovered').siblings('.hovered').removeClass('hovered');

            if ($(window).outerWidth() <= 1440) {
                $el.siblings().children('.submenu-wrapper').removeClass('opened');
                $this.siblings('.submenu-wrapper').toggleClass('opened');
            }
        });

        $wrapper.on('click', '.js-back-menu', function (e) {
            var $this = $(this);

            $this.closest('.submenu-wrapper').removeClass('opened');
            $this.closest('li').removeClass('hovered');
        });
    }  

    $('.js-mobile-btn').on('click', function (e) {
        if ($('html').hasClass("show-canvas")) {
            $('html').removeClass("show-canvas");
            $('.site-overlay').hide();
            $('.submenu-wrapper', $wrapper).removeClass("opened");
            $('.nav-1 > li', $wrapper).removeClass('hovered');         
        } else {
            $('html').addClass("show-canvas");
            $('.site-overlay').fadeIn(200);
        }
    });

    $('.site-overlay').on('click', function (e) {
        $('html').removeClass("show-canvas");
        $('.site-overlay').hide();
        $('.submenu-wrapper', $wrapper).removeClass("opened");
        $('.nav-1 > li', $wrapper).removeClass('hovered');       
    });

    // Only run the reset once when crossing the 1440px threshold (down or up)
    var prevIsUnder1440 = $(window).outerWidth() <= 1440;

    $(window).on('resize', function () {
        var currIsUnder1440 = $(window).outerWidth() <= 1440;

        // if state didn't change (still under or still over), do nothing
        if (currIsUnder1440 === prevIsUnder1440) return;

        // state changed: reset menu and update flag
        $('.submenu-wrapper', $wrapper).removeClass('opened');
        $('.nav-1 > li', $wrapper).removeClass('hovered');

        prevIsUnder1440 = currIsUnder1440;
    });
}

function initMainMenuEffects($submenus) {

    if ($submenus.length == 0)
        return;

    var config = {
        sensitivity: 10,
        interval: 80,
        over: mouseenter,
        timeout: 200,
        out: mouseleave
    };

    function mouseenter() {
        var $el = $(this);
        $el.siblings(".hovered").removeClass('hovered');
        $el.addClass('hovered').siblings('.hovered').removeClass('hovered');
    }

    function mouseleave() {
        return;
    }

    $submenus.parent().hoverIntent(config);
}

